import { AppPricingPlan } from '@/constants/enum';
import { shopSelector } from '@/redux/slice/shop.slice';
import { useSelector } from 'react-redux';

const UserPlans = () => {
  const infoShop = useSelector(shopSelector);

  const appPlanCurrent =
    infoShop?.appPlan === AppPricingPlan.Free
      ? 'free'
      : infoShop?.appPlan === AppPricingPlan.Basic
      ? 'basic'
      : AppPricingPlan.Premium;

  // Pricing in App

  const isUserFree = appPlanCurrent === 'free';

  const isUserBasic = appPlanCurrent === 'basic';

  const isUserFreeOrBasic = isUserFree || isUserBasic;

  const isUserPremium = appPlanCurrent === AppPricingPlan.Premium;

  return {
    appPlanCurrent,
    isUserFree,
    isUserBasic,
    isUserPremium,
    isUserFreeOrBasic,
  };
};

export default UserPlans;
